export default {
    addCart(context,payload) {


        let oldProduct = null;
        // for(let item of state.cartList){
        //   if(item.idd===payload.iid){
        //     oldProduct=item;
        //   }
        // }
        oldProduct = context.state.cartList.find(item => item.iid === payload.iid);
        if (oldProduct) {
            // oldProduct.count += 1;
            context.commit('addCount',oldProduct);
        } else {
            payload.count = 1;
            // context.state.cartList.push(payload);
            context.commit('addToCart',payload);
        }
    }
}